import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { ActivatedRoute, Router } from '@angular/router';

interface CommunityAddress {
  address?: string;
  streetAddress?: string;
  googleAddress?: string;
  coordinates?: number[];
  type?: string;
}

interface CommunityProfile {
  primaryAddress?: CommunityAddress;
  secondaryAddress?: CommunityAddress;
  address?: CommunityAddress;
  [key: string]: any;
}

@Component({
  selector: 'app-profile-management',
  templateUrl: './profile-management.component.html',
  styleUrls: ['./profile-management.component.css']
})
export class ProfileManagementComponent implements OnInit {
  communityID = '';
  communityData: CommunityProfile | null = null;
  currentUser: { id?: string } | null = null;
  loading = false;
  constructor(private authService: AuthservicesService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    const rawUser = localStorage.getItem('ministry_currentUser');
    this.currentUser = rawUser ? JSON.parse(rawUser) : null;
    this.communityID = this.currentUser?.id || '';
    if (this.communityID) {
      this.communityDetail(this.communityID);
    }
  }

  communityDetail(id: string) {
    this.authService.communitydetails(id).subscribe((res: { data?: CommunityProfile }) => {
      this.loading = true;
      const data = res?.data || {};
      const primaryAddress = data?.primaryAddress
        ? {
            ...data.primaryAddress,
            streetAddress: data.primaryAddress.address || data.primaryAddress.streetAddress || '',
            googleAddress: data.primaryAddress.googleAddress || data.primaryAddress.address || '',
          }
        : data?.address;

      const secondaryAddress = data?.secondaryAddress
        ? {
            ...data.secondaryAddress,
            streetAddress: data.secondaryAddress.address || data.secondaryAddress.streetAddress || '',
            googleAddress: data.secondaryAddress.googleAddress || data.secondaryAddress.address || '',
          }
        : data?.secondaryAddress;

      this.communityData = {
        ...data,
        address: primaryAddress,
        secondaryAddress,
      };
    },
      error => {
        console.log(error);
      })
  }


}
